import {isNumber} from 'lodash';
import {ReactText, useEffect} from 'react';
import {Slide, toast} from 'react-toastify';

import {ComplianceHint} from 'types';

import {AudioComplianceHint} from './AudioComplianceHint';

import './styles.scss';

const activeToastIds = new Map<string, Set<ReactText>>();

const show = (hint: ComplianceHint) => {
    const toastIds = activeToastIds.get(hint.sessionId) || new Set<ReactText>();
    activeToastIds.set(hint.sessionId, toastIds);
    const id = toast(<AudioComplianceHint hint={hint} />, {
        position: toast.POSITION.TOP_CENTER,
        className: 'audio-compliance-toast tw-bg-light tw-text-dark tw-rounded-xl tw-shadow-md tw-p-4 tw-border',
        bodyClassName: 'audio-compliance-body',
        closeOnClick: false,
        autoClose: isNumber(hint.durationSeconds) ? hint.durationSeconds * 1000 : false,
        transition: Slide,
        onClose: () => {
            toastIds.delete(id);
            if (!toastIds.size && activeToastIds.get(hint.sessionId) === toastIds) {
                activeToastIds.delete(hint.sessionId);
            }
        }
    });
    toastIds.add(id);
    return id;
};

export const audioComplianceNotifier = {show};

type Props = {
    sessionId: string;
};

export const AudioComplianceNotifier = ({sessionId}: Props) => {
    useEffect(() => () => {
        activeToastIds.get(sessionId)?.forEach((id) => toast.dismiss(id));
        activeToastIds.delete(sessionId);
    }, [sessionId]);

    return null;
};
